import { IconsConstants } from '~/composables/icons.constants';
import { useWebsiteStore } from '~/units/website/store';

export const SubComponentMixin = defineNuxtComponent({
  data() {
    return {
      icons: IconsConstants,
    };
  },

  computed: {
    colors() {
      const websiteStore = useWebsiteStore();
      return websiteStore.colors;
    },
  },
});
